import { ModalDialog } from "@zapier/design-system-beta";
import { useAtomValue, useSetAtom } from "jotai";
import {
  emitEventOnAICopilotStartSetter,
  emitUserInteractionEventSetter,
  showAIStreamCreateModalAtom,
  isAgentsEnabledAtom,
} from "@zapier/canvas-state";
import classNames from "classnames";
import { Suspense, useEffect } from "react";
import { AiPromptBox } from "@zapier/enriched-prompter";
import "@zapier/enriched-prompter/dist/enriched-prompter.css";

import { isStreamingZslAtom } from "../../atoms/streamingStatusAtoms";
import { handleCloseModalSetter } from "../../atoms/handleCloseModalSetter";
import { useStreamingPrompt } from "../../hooks/useStreamingPrompt";

import styles from "./AIStreamCreateModal.module.css";
import { showWelcomeModalAtom } from "../../atoms/showWelcomeModalAtom";

type Props = {
  submitPrompt: (args: any) => void;
};

export function AIStreamCreateModalWrapper() {
  const { submitPrompt } = useStreamingPrompt();
  const showWelcomeModal = useAtomValue(showWelcomeModalAtom);
  const showAIStreamCreateModal = useAtomValue(showAIStreamCreateModalAtom);

  // Return early if neither modal should be shown
  if (!showWelcomeModal && !showAIStreamCreateModal) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <AIStreamCreateModal submitPrompt={submitPrompt} />
    </Suspense>
  );
}

export function AIStreamCreateModal({ submitPrompt }: Props) {
  const isAgentsEnabled = useAtomValue(isAgentsEnabledAtom);
  const showAIStreamCreateModal = useAtomValue(showAIStreamCreateModalAtom);
  const emitEventOnAICopilotStart = useSetAtom(emitEventOnAICopilotStartSetter);
  const emitUserInteractionEvent = useSetAtom(emitUserInteractionEventSetter);

  useEffect(() => {
    // Start tracking the AI Copilot start event when the modal is opened
    emitEventOnAICopilotStart();
  }, [emitEventOnAICopilotStart]);

  const handleCloseModal = useSetAtom(handleCloseModalSetter);
  const isLoading = useAtomValue(isStreamingZslAtom);

  return (
    <ModalDialog.Root
      isOpen={true}
      onOpenChange={handleCloseModal}
      className={classNames(styles.modalContentOverrideAiDiscovery, {
        [styles.modalContentOverride]: showAIStreamCreateModal,
      })}
      isDismissable={!isLoading}
      aria-labelledby="ai-prompt-box-header"
    >
      <AiPromptBox
        handleSubmit={submitPrompt}
        emitUserInteractionEvent={emitUserInteractionEvent}
        showAgentsNodes={isAgentsEnabled}
      />
    </ModalDialog.Root>
  );
}
